import { SurveyPriorityFeedQuery } from 'capability-ng-survey';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IContentTileActionObj } from 'ui-ng-content-tile';
import { CheckScheduledPollsServant } from './../servants/check_scheduled_poll_servant';

export class RedirectAfterPollForSurveyCommand {
  constructor(
    private loadActiveSurveysCommand: ICommand,
    private ngSurveyPriorityFeedQuery: SurveyPriorityFeedQuery,
    private $state: ng.ui.IStateService,
    private ngCheckScheduledPollsServant: CheckScheduledPollsServant
  ) {}
  redirect() {
    const getQuickPollOnly = true;
    this.loadActiveSurveysCommand(getQuickPollOnly).then(() => {
      const noQPSurveyExist = _4.isEmpty(this.ngSurveyPriorityFeedQuery.result);
      const REDIRECT_URL_KEY = 'sgdRedirectUrl';
      const sgdRedirectUrl = localStorage.getItem(REDIRECT_URL_KEY);
      if (noQPSurveyExist) {
        if (sgdRedirectUrl) {
          location.assign(sgdRedirectUrl);
          localStorage.removeItem(REDIRECT_URL_KEY);
          return;
        }

        return this.$state.go(this.ngCheckScheduledPollsServant.defaultRoute);
      }

      const firstSurveyAction = this.ngSurveyPriorityFeedQuery.result[0].action as unknown as IContentTileActionObj;
      return this.$state.go(firstSurveyAction.state, firstSurveyAction.params);
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/commands/redirect_after_poll_for_survey_command.ts